import React, { Component } from 'react'

export default class Sucesso extends Component {

    render() {
        return (
            <div className='successWrapper d-flex flex-column justify-content-center'>
                <h3 className='tx-blue font-weight-bold'>Pagamento recebido!</h3>
                <label className='font-weight-bold'>Entre alguns minutos e algumas horas você receberá seus tokens em seu endereço Solana!</label>
            </div> 
        )
    }
}